import { BookingSources } from "./BookingSources";
import { BookingExternalSourcesLabels } from "./BookingExternalSourcesLabels";

export const BookingSourcesLabels = {
  [BookingSources.OBBY]: "Obby",
  [BookingSources.WIDGET]: "Widget",
  [BookingSources.PRIVATE]: "Private",
  ...BookingExternalSourcesLabels
};
